import React from "react";
import RadioGroup from "Shared/RadioGroup";
import RadioInput from "Shared/RadioGroup/RadioInput";
import { useTranslation } from "react-i18next";

interface AddTaxesBooleanProps {
    onChange: (name: string, value: "yes" | "no") => void;
    isDefault: boolean;
}

const AddTaxesBooleanToggle = ({
   onChange,
   isDefault
}: AddTaxesBooleanProps) => {
    const { t } = useTranslation();

    return (
        <RadioGroup
            className={"customer_requested_taxes_radio"}
            onChange={onChange}
            name="UserAddedTaxes"
        >
            <RadioInput
                label={t("CustomerRequestedTaxes.addTaxes")}
                id="addTaxes"
                value="yes"
                isDefault={isDefault}
            />
            <RadioInput
                label={t("CustomerRequestedTaxes.notNow")}
                id="notNow"
                value="no"
                isDefault={!isDefault}
            />
        </RadioGroup>
    );
};

export default AddTaxesBooleanToggle;
